import { z } from 'zod';

export const wciaFormSchema = z
    .object({
        firstName: z.string({ error: 'cart:wcia.firstnameValidator' }),
        lastName: z.string({ error: 'cart:wcia.lastnameValidator' }),
        email: z.email({
            error: (issue) => (issue.input === undefined ? 'cart:wcia.mailValidator' : 'cart:wcia.mailFormatValidator'),
        }),
        phoneCountryCode: z.string({
            error: 'cart:wcia.phoneCountryCodeValidator',
        }),
        phoneNumber: z.string({ error: 'cart:wcia.phoneNumberValidator' }),
        consent: z.boolean(),
    })
    .refine(
        // SalesForce/Banner requirements for phone numbers
        (data) => {
            const combinedPhone = (data?.phoneCountryCode + data?.phoneNumber).replace(/\s+/g, '');
            const isNorwegianNumber = combinedPhone.startsWith('+47');
            if (isNorwegianNumber) {
                return combinedPhone.length === 11;
            } else {
                return combinedPhone.length >= 8 && combinedPhone.length <= 16;
            }
        },
        {
            path: ['phoneNumber'],
            error: 'cart:wcia.phoneNumberFormatValidator',
        },
    );

export type WciaFormValues = z.infer<typeof wciaFormSchema>;

export type WciaRequest = WciaFormValues & {
    language: 'no' | 'en';
    bannerProductId: string | null;
};
